import React from "react";
import { Link } from "react-router-dom";
import Shared from "../../../../components/ReUseAbleComponents/Shared";

function SingleArticleCategory(props) {
  return (
    <>
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-box dx-box-decorated">
                <div className="dx-blog-post">
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <h2 className="h4 mnt-5 mb-8">Quantial</h2>

                    <ul className="dx-breadcrumbs text-left dx-breadcrumbs-dark mnb-8">
                      <li>
                        <Link to="/help-center">Support Home</Link>
                      </li>
                      <li>
                        <Link to="/articles">Articles</Link>
                      </li>
                      <li>Quantial</li>
                    </ul>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-blog-post-box">
                    <div className="dx-article dx-article-block">
                      <h4 className="h6 dx-article-title">
                        <Link to="/single-article">
                          Make menu dropdown working without JavaScript
                        </Link>
                      </h4>
                      <div className="dx-article-text">
                        <p className="mb-0">
                          Meat all together sea deep isn&#39;t replenish called.
                          One moved cattle bring. Can&#39;t of. Itself After
                          shall hath winged. Given stars second whose yielding
                          fourth. Subdue years form saw. Second...
                        </p>
                      </div>
                      <Link
                        to="/single-article"
                        className="dx-btn dx-btn-link d-flex dx-article-link"
                      >
                        Read More{" "}
                        <span className="icon pe-7s-angle-right"></span>
                      </Link>
                    </div>
                    <div className="dx-article dx-article-block">
                      <h4 className="h6 dx-article-title">
                        <Link to="/single-article">Google Analytics</Link>
                      </h4>
                      <div className="dx-article-text">
                        <p className="mb-0">
                          Likeness seed he may. Brought firmament won&#39;t that
                          to. Fowl thing saw behold earth land evening gathering
                          hath after all whales winged. Greater so all two dry.
                          Appear seas fruit...
                        </p>
                      </div>
                      <Link
                        to="/single-article"
                        className="dx-btn dx-btn-link d-flex dx-article-link"
                      >
                        Read More{" "}
                        <span className="icon pe-7s-angle-right"></span>
                      </Link>
                    </div>
                    <div className="dx-article dx-article-block">
                      <h4 className="h6 dx-article-title">
                        <Link to="/single-article">
                          How to manually import Demo data (if you faced with
                          problems in one-click demo import)
                        </Link>
                      </h4>
                      <div className="dx-article-text">
                        <p className="mb-0">
                          And have make, isn&#39;t land herb good lesser
                          won&#39;t. Own. Us. Moveth, divided female their
                          won&#39;t subdue seas tree creepeth They&#39;re
                          morning isn&#39;t let so lights. Sixth, first every
                          night...
                        </p>
                      </div>
                      <Link
                        to="/single-article"
                        className="dx-btn dx-btn-link d-flex dx-article-link"
                      >
                        Read More{" "}
                        <span className="icon pe-7s-angle-right"></span>
                      </Link>
                    </div>
                    <div className="dx-article dx-article-block">
                      <h4 className="h6 dx-article-title">
                        <Link to="/single-article">WordPress Themes FAQ</Link>
                      </h4>
                      <div className="dx-article-text">
                        <p className="mb-0">
                          Us sixth she&#39;d, which creeping fruitful winged. To
                          called made seas of grass creature good upon. Air
                          multiply gathering female saying our set creepeth
                          wherein hath waters from midst man...
                        </p>
                      </div>
                      <Link
                        to="/single-article"
                        className="dx-btn dx-btn-link d-flex dx-article-link"
                      >
                        Read More{" "}
                        <span className="icon pe-7s-angle-right"></span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className="dx-sticky dx-sidebar"
                data-sticky-offsetTop="120"
                data-sticky-offsetBot="40"
              >
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">
                    {" "}
                    Subscribe to Newsletter{" "}
                  </div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">Articles Categories</div>
                  <ul className="dx-widget-categories">
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Quantial
                        </span>
                        <span className="dx-widget-categories-badge">(4)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Sensific
                        </span>
                        <span className="dx-widget-categories-badge">(4)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Minist
                        </span>
                        <span className="dx-widget-categories-badge">(8)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Desty
                        </span>
                        <span className="dx-widget-categories-badge">(2)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Silies
                        </span>
                        <span className="dx-widget-categories-badge">(3)</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Articles </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      How to manually import Demo data (if you faced with
                      problems in one-click demo import)
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Make menu dropdown working without JavaScript
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Add top menu link inside dropdown on mobile devices
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Forum Topics </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Need help with customization. Some options are not
                      appearing...
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      My images on profile and item pages doesnt show up?! Whats
                      the matter?
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Theme not updating in downloads
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleArticleCategory;
